export default __webpack_public_path__ + "static/media/itribe-logo2.d523be25.svg";